/** Counts Unicode code points, not UTF-16 code units. BE-14 remains the final authority. */
export const countIpawsCharacters = (value = '') => Array.from(value).length;

export const IPAWS_PUBLIC_MESSAGE_LIMITS = {
  headline: 160,
  description: 900,
  instruction: 900,
};

export const getIpawsCharacterCountState = (value, limit) => {
  const count = countIpawsCharacters(value);
  if (count > limit) return { count, tone: 'over' };
  if (count >= Math.floor(limit * 0.8)) return { count, tone: 'warning' };
  return { count, tone: 'normal' };
};
